<script setup lang="ts">
import { ExternalGooglePlace, InlineGooglePlace } from '@/modules/search-location/components';

const props = withDefaults(
  defineProps<{
    label?: string;
    errorMessages?: string | string[];
    readonly?: boolean;
    disabled?: boolean;
    externalAPI?: boolean;
    placeId?: string;
  }>(),
  {
    label: 'Enter Location',
    errorMessages: '',
    readonly: false,
    disabled: false,
    externalAPI: true,
    placeId: '',
  }
);

const data = defineModel<string | number | object>();
</script>

<template>
  <ExternalGooglePlace v-if="externalAPI" v-model="data" :place-id="placeId" v-bind="props" />
  <InlineGooglePlace v-else v-model="data" v-bind="props" :place-id="placeId" />
</template>
